import { Container, Skeleton, Typography } from "@mui/material"

const ConfigLoader = () => {
  return (
    <>
      <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          <Skeleton variant="text" width={175} />
        </Typography>

        <Skeleton variant="rectangular" width="100%" height={100} />
      </Container>
    </>
  )
}

export default ConfigLoader;
